import React, { useState, useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import { IoIosDownload } from 'react-icons/io';
import { RiFilterFill } from 'react-icons/ri';
import { RiFilterOffFill } from 'react-icons/ri';
import { RiSendPlaneFill } from "react-icons/ri";
import { AiFillStop } from "react-icons/ai";
import { CgSpinner } from 'react-icons/cg';

import Alert from 'common-components/Alert';
import UrlDiffModal from '../UrlDiffModal';
import ConfirmIgnore from '../ConfirmIgnore';
import useKeyboardShortcut from 'lib/keyboard-shortcut';
import Filter from '../Filter';
import {
  SERVER_ERROR,
  LOGIN_ERROR
} from 'common-components/Alert/alertMessage.config';
import { fetchURLs } from '../../api';
import {
  setUnpublishedURLs,
  setFilteredURLs
} from 'redux/urls/url.action';
import {
  prepareQuery,
  raiseEmptyFetch,
  getFilteredData
} from '../../utils';

import './menuBar.style.css';


const MenuBar = ({
  authHeader,
  isLoading,
  dropDownCat,
  unPublishedUrls,
  filterApplied,
  setFilteredURLs,
  setUnpublishedURLs,
  setFilterApplied
}) => {
  const [alertData, setAlertData] = useState({});
  const [showFetchFilter, setShowFetchFilter] = useState(false);
  const [showTableFilter, setShowTableFilter] = useState(false);
  const [showDiffModal, setShowDiffModal] = useState(false);
  const [showIgnoreConfirmAlert, setShowIgnoreConfirmAlert] = useState(false);
  const [fetchFilterData, setFetchFilterData] = useState(null);
  const [tableFilterValues, setTableFilterValues] = useState(null);
  const [fetchSpinner, setFetchSpinner] = useState(false);

  const fetchKey = ['Shift', 'F'];
  const tableFilterKey = ['Shift', 'T'];
  const publishSavedKey = ['Shift', 'P'];
  const clearIngoredKey = ['Shift', 'C'];

  const handleFetchKeyboardShortcut = useCallback(keys => {
    setShowFetchFilter(true);
  }, [setShowFetchFilter]);

  const handleTableFilterShortcut = useCallback(keys => {
    tableFilterHandler();
  }, [setShowTableFilter]);

  const handlePublishSavedShortcut = useCallback(keys => {
    setShowDiffModal(true);
  }, [setShowDiffModal]);

  const handleClearIgnoredShortcut = useCallback(keys => {
    setShowIgnoreConfirmAlert(true);
  }, [setShowIgnoreConfirmAlert]);

  useKeyboardShortcut(fetchKey, (isLoading || fetchSpinner) ? () => { } : handleFetchKeyboardShortcut);
  useKeyboardShortcut(tableFilterKey, isLoading ? () => { } : handleTableFilterShortcut);
  useKeyboardShortcut(publishSavedKey, isLoading ? () => { } : handlePublishSavedShortcut);
  useKeyboardShortcut(clearIngoredKey, isLoading ? () => { } : handleClearIgnoredShortcut);

  const initiateFetchUrl = async () => {
    setFetchSpinner(true);

    let data;
    let query = prepareQuery(fetchFilterData);
    let response = await fetchURLs(authHeader, query);

    if (response && response.status == 401) setAlertData(LOGIN_ERROR);
    else if (response && response.status == 204) raiseEmptyFetch(setAlertData);
    else if (response && response.status.toString().match(/2\d{2}/)) data = response.data;
    else setAlertData(SERVER_ERROR);

    setUnpublishedURLs(data);
    setFetchSpinner(false);
  };

  useEffect(() => {
    if (fetchFilterData) {
      initiateFetchUrl();
      setFetchFilterData(null);
    };

    if (tableFilterValues && unPublishedUrls) {
      setFilterApplied(true);
      let data = getFilteredData(tableFilterValues, unPublishedUrls);
      setFilteredURLs(data);
      setTableFilterValues(null);
    };
  }, [fetchFilterData, tableFilterValues]);

  const tableFilterHandler = () => {
    if (filterApplied) {
      setFilteredURLs(null);
      setFilterApplied(false);
    } else {
      setShowTableFilter(true);
    };
  };

  return (
    <>
      <div className='menu'>
        <div className={`icon-container-green ${isLoading || fetchSpinner ? ' disabled-operation' : ''}`}
          onClick={() => setShowFetchFilter(true)} >
          <span> <IoIosDownload className='icon' /> </span>
          <span className='icon-name'>Fetch</span>
          {fetchSpinner &&
            (<span className='fetch-spinner'>
              <CgSpinner className='spin' />
            </span>
            )}
        </div>
        <div className={`icon-container-black ${isLoading ? ' disabled-operation' : ''}`}
          onClick={() => tableFilterHandler()} >
          <span>
            {filterApplied ? <RiFilterOffFill className='icon' /> : <RiFilterFill className='icon' />}
          </span>
          <span className='icon-name'>Table Filter</span>
        </div>
        <div className={`icon-container-green ${isLoading ? ' disabled-operation' : ''}`}
          onClick={() => setShowDiffModal(true)}>
          <span> <RiSendPlaneFill className='icon' /> </span>
          <span className='icon-name'>Publish Saved</span>
        </div>
        <div className={`icon-container-red ${isLoading ? ' disabled-operation' : ''}`}
          onClick={() => setShowIgnoreConfirmAlert(true)}>
          <span> <AiFillStop className='icon' /> </span>
          <span className='icon-name'>Clear Ignored</span>
        </div>
      </div>
      {showTableFilter &&
        <Filter
          header='Table Filter'
          showFilter={showTableFilter}
          setShowFilter={setShowTableFilter}
          setData={setTableFilterValues}
          dropDownCat={dropDownCat}
          eventName='Apply Filter'
          type='TABLE_FILTER'
        />}
      {showFetchFilter && (
        <Filter
          header='Fetch URLs'
          showFilter={showFetchFilter}
          setShowFilter={setShowFetchFilter}
          setData={setFetchFilterData}
          eventName='Fetch'
          dropDownCat={dropDownCat}
          type='FETCH_FILTER'
        />
      )}
      { showDiffModal && (
        <UrlDiffModal
          showDiffModal={showDiffModal}
          setShowDiffModal={setShowDiffModal}
        />
      )}
      <ConfirmIgnore
        showModal={showIgnoreConfirmAlert}
        setShowModal={setShowIgnoreConfirmAlert}
      />
      <Alert
        showModal={alertData.showModal}
        setShowModal={setAlertData}
        data={alertData}
      />
    </>
  )
};

const mapStateToProps = ({
  authentication: { authHeader },
  URLs: { unPublishedUrls } }) => ({
    authHeader,
    unPublishedUrls
  });

const mapDispatchToProps = dispatch => ({
  setUnpublishedURLs: urls => dispatch(setUnpublishedURLs(urls)),
  setFilteredURLs: urls => dispatch(setFilteredURLs(urls))
});

export default connect(mapStateToProps, mapDispatchToProps)(MenuBar);
